import { render, staticRenderFns } from "./UserLinkStatusDialog.vue?vue&type=template&id=7939b29f&scoped=true"
import script from "./UserLinkStatusDialog.vue?vue&type=script&lang=js"
export * from "./UserLinkStatusDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7939b29f",
  null
  
)

export default component.exports